import { RadioGroup,Radio,Divider,Box, Table,Thead,Tbody,Badge,Tr,Th,Td,TableContainer,Alert, AlertIcon, Button, Stack, Flex, Spacer, Input, InputLeftElement, InputGroup, IconButton, useDisclosure, Drawer, DrawerBody,
    Menu,MenuButton,MenuList, MenuItem,DrawerHeader,DrawerOverlay, DrawerContent, } from '@chakra-ui/react'
import {CheckCircleIcon,MinusIcon,SmallAddIcon, EditIcon, InfoIcon, SearchIcon, HamburgerIcon} from '@chakra-ui/icons';
import { useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react';
import GruntComponents from '../components';
import ComponentHeader from './ComponentHeader';
import OperaterViewData from '../operater/OperaterViewData'
import { GruntComponentAction, GruntGetRequestOptions, loggedOper as lp,colorSchmemes } from '../../util/grunt';
//import { getOperateri } from "../../util/apiCalls";


const Operateri = ({onClosePress}) => {
    const [selectedoper,setSelectedOper]=useState(-1);
    const [errloading,setErrLoading]=useState(false);
    const [errmsg,setErrMsg]=useState("Greška kod učitavanja podataka!");
    const [ascdesc,setAscDesc]=useState('asc');
    const [orderby,setOrderBy]=useState('id')
    const [prikazaktneakt, setPrikazaktneakt] = useState("akt");
    //const [newoper,setNewOper]=useState(false);
    //const [newopererr,setNewOperErr]=useState(false);
    const [operchangeddata, setOperChangedData]=useState(0);
    const [operateri0,setOperateri0]=useState([]);
    const [operateri,setOperateri]=useState([]);
    const [aktivnost,setAktivnost]=useState(GruntComponentAction.Read);
    const { isOpen, onOpen, onClose } = useDisclosure()
    //const [lp, setLp]=useState(loggedOper);
    const userCanEdit=lp.uloga==="a"?true:false;
    const fetchOperateri=()=>{
        let isErr=false;
        GruntGetRequestOptions.headers.Authorization= lp.token;
        const API_Operateri=process.env.REACT_APP_GRUNT_API+'/operater';
        fetch(API_Operateri,GruntGetRequestOptions)
        .then((res)=>{
            //setNewOper(false);
            //setNewOperErr(false);
           
            if (res.status!==200) {
                isErr=true;
                /*setErrLoading(true);
                const r=res.json();
                setErrMsg("Greška kod učitavanja podataka! Status=" +r.status+" ("+r.message+")");*/
            }
            return res.json();
        })
        .then((res)=>{
                if (isErr) {
                    setErrLoading(true);
                    setErrMsg("Greška kod učitavanja podataka! Status=" +res.status+" ("+res.message+")");
                } else {
                    setOperateri0(res);
                    setOperateri(res.filter((op)=>{return op.aktivan===(prikazaktneakt==="akt"?true:false)}));
                }
                
            
        }).catch((err)=>{
            setErrLoading(true)
        })
        
    }
    
//učitvanje operatera   
    useEffect(()=>{
        
        fetchOperateri();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[operchangeddata])
    


    const onTRowClick=(e)=>{
        setSelectedOper(e);
    }

    /*const resetMessages=()=>{
        setNewOperErr(false);
        setNewOper(false);
    }*/
    const setOrderByColumn=(propname)=>{
        let ad='asc';
        if (propname===orderby){
            //setAscDesc(ascdesc==='asc'?'dsc':'asc');
            ad=(ascdesc==='asc'?'dsc':'asc');
        } else {
            setOrderBy(propname);
            
        }
        setAscDesc(ad);
        setOperateri(operateri.sort((a,b)=>{
            if (ad==='asc') {
                return a.id-b.id;
            } else {
                return b.id-a.id;
            }
        }));
    }
    const getOrderImage=(propname)=>{
        let _res="⋮";
        if (propname===orderby){
            _res="▴"
            if (ascdesc==="dsc") {
                _res="▾"
            }
        }
        return _res;
    }

    const filterData=(filter)=>{
        let _res=[];
        if (filter==="" ){
            if (prikazaktneakt==="sve"){
                setOperateri(operateri0);
            } else {
                setOperateri(operateri0.filter((oper)=>{
                    return oper.aktivan===(prikazaktneakt==="akt"?true:false)
                }));
            }
            
            return;
        }
        else {
            if (prikazaktneakt==="sve") {
            _res=operateri0.filter((operater)=>{
                return operater.ime.toLowerCase().includes(filter.toLowerCase()) || operater.prezime.toLowerCase().includes(filter.toLowerCase());
            });
            } else {
                _res=operateri0.filter((operater)=>{
                    return (operater.ime.toLowerCase().includes(filter.toLowerCase()) || (operater.prezime.toLowerCase().includes(filter.toLowerCase()) && operater.aktivan===(prikazaktneakt==="akt"?true:false)));
                })
            }
        setOperateri(_res);
    }
}
    const filterByAktivanNeaktivan=(filter)=>{
        let _res=[];
        //const filter=prikazaktneakt;
        if (filter==="sve"){
            _res=operateri0;
        } else {
            _res=operateri0.filter((operater)=>{
                return operater.aktivan===(filter==="akt"?true:false);
            })
        }
        setOperateri(_res);
    }
    const toast=useToast();
    const deleteOper=(id)=>{
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json','Authorization':lp.token },
        };
        fetch(process.env.REACT_APP_GRUNT_API+'/operater/'+id, requestOptions)
        .then((res)=>{
            if (res.status===200) {
                setOperChangedData(operchangeddata+1);
                toast({
                    title:"Operater deaktiviran/aktiviran",
                    status:"success",
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
                
                onClose();
            } else {
                toast({
                    title:"Greška kod deaktivacije/aktivacije operatera",
                    status:"error",
                    description:res.message,
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
            }
        })
        .catch((ex)=>{
            toast({
                title:"Greška kod deaktivacije/aktivacije operatera",
                status:"error",
                isClosable:true,
                duration:3000,
                position:"top-right",
            });
        })
    }
    const createOper=(id,ime,prezime,email,usr,pwd,uloga)=>{
        
        const _newoper={
            ime:ime,
            prezime:prezime,
            email:email,
            usr:usr,
            pwd:pwd,
            uloga:uloga,
        };
        
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization':lp.token },
            body: JSON.stringify(_newoper)
        };
        fetch(process.env.REACT_APP_GRUNT_API+'/operater', requestOptions)
            .then((res) => {
                    
                    
                if (res.status===201){
                    fetchOperateri(); 
                    //setNewOper(true);
                    toast({
                        title:"Operater uspješno unesen",
                        status:"success",
                        isClosable:true,
                        duration:3000,
                        position:"top-right",
                    });
                   
                    onClose();
                } else {
                    
                    
                    return res.json();
                }
            })
            .then((res)=>{
                //setNewOperErr(true);
                //setNewOperErrMsg(res.message);
                toast({
                    title:"Greška kod unosa operatera",
                    status:"error",
                    description:res.message,
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
            })
            .catch((err)=>{
                //setNewOperErr(true);
            });
    
    }

    // const contrUrediPodatke=()=>{
        
    //     if (userCanEdit) {
    //         return (
    //             <Stack direction={'row'} spacing={'1rem'}>
    //                 <Tooltip label="Uredi podatke">
    //                     {<IconButton children={<EditIcon/>} variant={'solid'} size={'xs'} colorScheme={'grunt2'} onClick={()=>{setAktivnost(GruntComponentAction.Edit);onOpen()}}></IconButton>}
    //                 </Tooltip>
    //             </Stack>
    //         )
    //     } else {
    //         return (
    //             <Stack direction={'row'} spacing={'1rem'}>
    //                     {<IconButton disabled={'true'} children={<EditIcon/>} variant={'solid'} size={'xs'} colorScheme={'gray'}></IconButton>}
    //             </Stack>
    //         )
    //     }
    // }
    const updateOper=(id,ime,prezime,email,usr,uloga)=>{
        
        const _oper={
            ime:ime,
            prezime:prezime,
            email:email,
            usr:usr,
            uloga:uloga,
        };
        
        
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json','Authorization':lp.token },
            body: JSON.stringify(_oper)
        };
        fetch(process.env.REACT_APP_GRUNT_API+'/operater/' + id, requestOptions)
            .then((res) => {
                    
                    
                if (res.status===200){
                    fetchOperateri(); 
                    //setNewOper(true);
                    toast({
                        title:"Operater uspješno ažuriran",
                        status:"success",
                        isClosable:true,
                        duration:3000,
                        position:"top-right",
                    });
                   
                    onClose();
                } else {
                    
                    
                    return res.json();
                }
            })
            .then((res)=>{
                //setNewOperErr(true);
                //setNewOperErrMsg(res.message);
                toast({
                    title:"Greška kod ažuriranja operatera",
                    status:"error",
                    description:res.message,
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
            })
            .catch((err)=>{
               // setNewOperErr(true);
            });
    
    }

    const updateOperPwd=(id,pwd)=>{
        
        const _oper={
            pwd:pwd,
        };
        
        
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' ,'Authorization':lp.token},
            body: JSON.stringify(_oper)
        };
        fetch(process.env.REACT_APP_GRUNT_API+'/operater/pwd/' + id, requestOptions)
            .then((res) => {
                    
                    
                if (res.status===200){
                    fetchOperateri(); 
                   // setNewOper(true);
                    toast({
                        title:"Lozinka uspješno ažurirana",
                        status:"success",
                        isClosable:true,
                        duration:3000,
                        position:"top-right",
                    });
                   onClose();
                    
                } else {
                    
                    
                    return res.json();
                }
            })
            .then((res)=>{
                //setNewOperErr(true);
                //setNewOperErrMsg(res.message);
                toast({
                    title:"Greška kod ažuriranja lozinke",
                    status:"error",
                    description:res.message,
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
            })
            .catch((err)=>{
               // setNewOperErr(true);
            });
    
    }

    const handleChange=(e)=>{
        
        filterByAktivanNeaktivan(e);
        setPrikazaktneakt(e);
    }
    
    const btnNew=()=>{
        if (userCanEdit) {
            return (
                <Button rightIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'outline'} size={'xs'}  onClick={()=>{setAktivnost(GruntComponentAction.Create);onOpen()}}>Dodaj</Button>
                )
        } else {
            return (
                <></>
                )
        }
    }
    return (
        
        <Box h={'92vh'} key='operateri_component' pl='0.5rem' pr={'0.5rem'} >
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Operateri}/>
                {!errloading?  (<Box>
                <Box pb='0.5rem' _disabled={errloading} display={'flex'} alignItems={'center'}>
                    <InputGroup size={'xs'} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={(e)=>filterData(e.target.value)}/>
                    </InputGroup>
                    
                    <RadioGroup onChange={handleChange} defaultValue={prikazaktneakt} ml='2rem' size={'sm'}>
                        <Stack direction='row'>
                            <Radio value='akt'>Aktivni</Radio>
                            <Radio value='neakt'>Neaktivni</Radio>
                            <Radio value='sve'>Svi</Radio>
                        </Stack>
                    </RadioGroup>
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                        {btnNew()}
                    </Stack>
                    
                
                
                </Box>
               
                <Flex direction={'column'}>
                <TableContainer overflowY={'auto'} h={'78vh'}>
                    <Table variant={'unstyled'} size='xs'>
                        <Thead _hover={{cursor:'pointer'}}>
                            <Tr>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setOrderByColumn('ime')}>Ime{getOrderImage('ime')}</Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setOrderByColumn('prezime')}>Prezime{getOrderImage('prezime')}</Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setOrderByColumn('email')}>Email{getOrderImage('email')}</Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setOrderByColumn('usr')}>Korisničko ime{getOrderImage('usr')}</Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Aktivan</Th>
                                <Th fontSize={'xs'} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Uloga</Th>
                                
                            </Tr>
                        </Thead>
                        <Tbody>
                        
                        { operateri.map((item,i)=>{
                            return (
                            
                            <Tr color={'grunt2'} key={item.id} 
                             _hover={{bg:'gray.100',cursor:'pointer'}} onClick={()=>onTRowClick(item)}>
                                <Td textAlign={'center'} fontSize={'xs'}>
                                    <Menu>
                                        <MenuButton
                                            as={IconButton}
                                            aria-label='Options'
                                            icon={<HamburgerIcon />}
                                            variant='outline' size={'xs'}
                                        />
                                        <MenuList>
                                            
                                            <MenuItem icon={<InfoIcon boxSize={'14px'} />}  onClick={()=>{setAktivnost(GruntComponentAction.Read);onOpen()}}>
                                                Pregled
                                            </MenuItem>
                                            <MenuItem isDisabled={!userCanEdit} icon={<EditIcon boxSize={'14px'} />} onClick={()=>{setAktivnost(GruntComponentAction.Edit);onOpen()}}>
                                                Uredi podatke
                                            </MenuItem>
                                        </MenuList>
                                    </Menu>
                                </Td>
                                <Td fontSize={'xs'} textAlign={'center'}>{item.ime}</Td>
                                <Td fontSize={'xs'} textAlign={'center'}>{item.prezime}</Td>
                                <Td fontSize={'xs'} textAlign={'center'}>{item.email}</Td>
                                <Td fontSize={'xs'} textAlign={'center'}>{item.usr}</Td>
                                <Td fontSize={'xs'} textAlign={'center'}>{item.aktivan===true?<CheckCircleIcon color={'green'}/>:<MinusIcon color={'red'}/>}</Td>
                                <Td fontSize={'xs'} textAlign={'center'}>
                                <Badge size={'xs'} colorScheme={colorSchmemes[(item.uloga_naziv.length+item.uloga_naziv.charCodeAt(0))%16]} variant={'solid'}>{item.uloga_naziv}</Badge>
                                    
                                </Td>
                            </Tr>
                        )})
                        } 
                        </Tbody>
                    </Table>
                </TableContainer>
                <Spacer/>
                <Divider orientation={'horizontal'}/>
                </Flex>
                
                </Box>
                
                ):(<Box>
                    <Alert typeof='error' colorScheme={'red'}>
                        <AlertIcon/>
                        {errmsg}
                    </Alert>
                    {/* <OperaterViewData GrCmpAct={GruntComponentAction.Read}/> */}
                    
                </Box>)}
                    
                <Drawer placement='right' size={'md'} onClose={onClose} isOpen={isOpen}>
                    <DrawerOverlay/>
                    <DrawerContent roundedTopLeft={'md'}>
                        <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                            
                            {aktivnost===GruntComponentAction.Read?"Pregled podataka operatera"
                            :aktivnost===GruntComponentAction.Edit?"Ispravak podataka":"Unos novog operatera"}
                            
                        </DrawerHeader>
                        <DrawerBody>
                            <OperaterViewData GrCmpAct={aktivnost} operater={aktivnost===GruntComponentAction.Create?undefined:selectedoper}  onCloseComponent={()=>{onClose()/*;resetMessages();*/}} 
                            onSaveData={createOper} onUpdate={updateOper} onDeleteData={deleteOper} onUpdatePwd={updateOperPwd}/>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            
        </Box>
        
    );
}

export default Operateri;